// src/pages/compras/Compras.tsx
import React, { useState, useEffect } from "react";
import { Box, Fade, CircularProgress } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import ComprasDataTable from "../../components/module/compras/ComprasDataTable";
import { ICompra } from '../../components/types/compras.types';
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PageLayout from "../../components/layout/PageLayout";
import { useNavigate } from 'react-router-dom';
import comprasApi from "../../services/api/comprasApi";
import DetalleCompraModal from "../../components/module/compras/DetalleCompraModal";
import { useTiposPagoApi } from "../../hooks/useTiposPagoApi";
import ViewCompraModal from "../../components/module/compras/ViewCompraModal";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";

// Tema profesional para compras
const Compras = () => {  
  const { darkMode } = useContext(DarkModeContext);
  
  const { tiposPago, isLoading: loadingTiposPago } = useTiposPagoApi();
  const [selectedCompra, setSelectedCompra] = useState<ICompra | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [compras, setCompras] = useState<ICompra[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [viewModalOpen, setViewModalOpen] = useState(false);

  useEffect(() => {
    loadCompras();
  }, []);

  const loadCompras = async () => {
    try {
      setIsLoading(true);
      const data = await comprasApi.getAllCompras();
      setCompras(data);
    } catch (error) {
      console.error("Error cargando compras:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateCompra = () => {
    navigate('/compras/new');
  };

  const handleCompraSelect = (compra: ICompra) => {
    setSelectedCompra(compra);
    setViewModalOpen(true);
  }; 
 
  const handleAddArticulos = (compra: ICompra) => {
    navigate(`/compras/detalle/${compra.Id}`, {
      state: { orderDetails: compra }
    });
  };

  const handleGestionarCompra = (compra: ICompra) => {
    setSelectedCompra(compra);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCompra(null);
  };

  const handleFinalizarCompra = async (data: any) => {
    try {
      await comprasApi.finalizarCompra(data);
      await loadCompras();
    } catch (error) {
      console.error("Error finalizando compra:", error);
      throw error;
    }
  };

  const handleCancelarCompra = async (id: number) => {
    try {
      await comprasApi.cancelarCompra(id);
      await loadCompras();
    } catch (error) {
      console.error("Error cancelando compra:", error);
      throw error;
    }
  };

  return (
    <div className="home">
        <div className="homeContainer">
          <div className="moduleContainer">
            <PageLayout icon={ShoppingCartIcon} title="Gestión de Compras">
              <Fade in timeout={300}>
                <Box sx={{ p: 3 }}>
                  {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                      <CircularProgress size={48} color="primary" />
                    </Box>
                  ) : (
                    <ComprasDataTable
                      items={compras}
                      onView={handleCompraSelect}
                      onAdd={handleCreateCompra}
                      onAddArticulos={handleAddArticulos}
                      onGestionarCompra={handleGestionarCompra}
                      isLoading={isLoading}
                    />
                  )}
                </Box>
              </Fade>

              {selectedCompra && (
                <DetalleCompraModal
                  open={modalOpen}
                  onClose={handleCloseModal}
                  compra={selectedCompra}
                  tiposPago={tiposPago}
                  onFinalize={handleFinalizarCompra}
                  onCancel={() => handleCancelarCompra(selectedCompra.Id)}
                />
              )}

              {selectedCompra && (
                <ViewCompraModal
                  open={viewModalOpen}
                  onClose={() => {
                    setViewModalOpen(false);
                    setSelectedCompra(null);
                  }}
                  compra={selectedCompra}
                />
              )}
            </PageLayout>
          </div>
        </div>
      </div>
  );
};

export default Compras;